import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { CaregiverSidebar } from "./CaregiverSidebar";
import { PortalHeader } from "@/shared/layout/PortalHeader";
import { usePatientAuthStore } from "@/stores/patientAuthStore";

const pageMeta: Record<string, { title: string; description: string }> = {
  "/caregiver": { title: "Shared With You", description: "Select a patient to view their shared records" },
  "/caregiver/access-activity": { title: "Access Activity", description: "Every request you've sent, and how each one was resolved" },
  "/caregiver/profile": { title: "Profile Settings", description: "Manage your caregiver account" },
};

function getInitials(name: string): string {
  return name.split(" ").filter(Boolean).slice(0, 2).map((p) => p.charAt(0)).join("").toUpperCase();
}

export function CaregiverLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = usePatientAuthStore((s) => s.user);
  const signOut = usePatientAuthStore((s) => s.signOut);
  const meta = pageMeta[location.pathname] ?? pageMeta["/caregiver"];
  const name = user?.name ?? "";

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <CaregiverSidebar name={name} />
      <div className="flex flex-1 flex-col overflow-hidden">
        <PortalHeader
          title={meta.title}
          description={meta.description}
          showNotifications
          avatarInitials={getInitials(name)}
          menuItems={[
            { label: "View Profile", onClick: () => navigate("/caregiver/profile") },
            { label: "Logout", onClick: () => signOut(), danger: true },
          ]}
        />
        <main id="main-content" className="msq-route-main flex-1 overflow-y-auto bg-[#F9F9F9]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
